import  React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { setDisplaySiteSurveyAlert } from './application_actions';
import {SiteSurveyBanner} from './components/presentational/site_survey_banner.jsx';
import NetworkToast from './components/common/NetworkToast.jsx';

class App extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div>
          <SiteSurveyBanner/>
          {this.props.children}
          <NetworkToast></NetworkToast>
      </div>
    );
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({setDisplaySiteSurveyAlert}, dispatch);
}

export default connect(null, mapDispatchToProps)(App);
